import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#080808] border-t border-white/10 text-[#A1A1AA]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo variant="light" />
          <p className="mt-5 font-display text-lg text-[#F6F3EC] tracking-tight leading-snug max-w-xs">Better AI needs better human judgment.</p>
          <p className="mt-3 text-sm leading-relaxed max-w-sm">The structured human capability layer behind better AI evaluation. Building from India for the global AI ecosystem.</p>
        </div>

        <div className="md:col-span-3">
          <span className="eyebrow text-[#71717A]">Navigate</span>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/ai-labs" className="hover:text-[#F6F3EC] link-underline">AI Labs</Link></li>
            <li><Link to="/experts" className="hover:text-[#F6F3EC] link-underline">Experts</Link></li>
            <li><Link to="/how-it-works" className="hover:text-[#F6F3EC] link-underline">How FIAD Works</Link></li>
            <li><Link to="/about" className="hover:text-[#F6F3EC] link-underline">About</Link></li>
            <li><Link to="/waitlist" className="hover:text-[#F6F3EC] link-underline">Waitlist</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <span className="eyebrow text-[#71717A]">Contact & legal</span>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><a href="mailto:contact.fiad@gmail.com" className="hover:text-[#F6F3EC] link-underline">contact.fiad@gmail.com</a></li>
            <li><Link data-testid="footer-terms" to="/terms" className="hover:text-[#F6F3EC] link-underline">Terms of Use</Link></li>
            <li><Link data-testid="footer-privacy" to="/privacy" className="hover:text-[#F6F3EC] link-underline">Privacy Policy</Link></li>
            <li><Link data-testid="footer-cookie" to="/cookie" className="hover:text-[#F6F3EC] link-underline">Cookie Notice</Link></li>
            <li><button data-testid="footer-cookie-prefs" onClick={() => window.dispatchEvent(new Event("fiad:open-cookie-preferences"))} className="hover:text-[#F6F3EC] link-underline text-left">Cookie preferences</button></li>
            <li><Link data-testid="footer-antiscam" to="/anti-scam" className="hover:text-[#F6F3EC] link-underline">Anti-Scam Notice</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span className="text-xs text-[#71717A]">© 2026 FIAD.DEV — Arkaprabho Ghosh, India.</span>
          <span className="text-xs text-[#71717A]">FIAD never charges experts.</span>
        </div>
      </div>
    </footer>
  );
}
